import {useCallback, useEffect} from 'react';
import {isRouteErrorResponse, useMatch, useNavigate} from 'react-router';

import {DEBUG} from '@/shared/config';
import {logger} from '@/shared/services/logger';
import {APP_ROUTES as APP_ROUTER} from '@/utils_legacy/routes';

type AppErrorProps = {
  error: Error | null | unknown;
};

const AppError = ({error}: AppErrorProps) => {
  const navigate = useNavigate();
  const homePage = useMatch({path: APP_ROUTER.Home, end: true});
  const stayOnPage = homePage || DEBUG;

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    logger.critical(`App crashed: ${String(error)}`, {
      error,
      errorMessage: String(error),
      isRouteErrorResponse: isRouteErrorResponse(error),
      stack: error instanceof Error ? error?.stack : undefined,
    });

    if (stayOnPage) {
      return;
    }

    navigate(APP_ROUTER.Home);
  }, [stayOnPage, navigate, error]);

  if (DEBUG) {
    throw error;
  }

  return (
    <div className="not-found flex h-screen w-screen flex-col items-center justify-center bg-white">
      <h2 className="mb-4 font-bold text-2xl text-error">
        We’re sorry this error occurred. Please try again later
      </h2>
      {stayOnPage && (
        <button
          onClick={handleReload}
          className="rounded border-1 bg-white px-4 py-2"
        >
          Reload
        </button>
      )}
    </div>
  );
};

export default AppError;
